var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
var ManageUsersClientService = /** @class */ (function () {
    function ManageUsersClientService(requestClient) {
        this.requestClient = requestClient;
    }
    ManageUsersClientService.prototype.getAllUsers = function (request) {
        return this.requestClient.get("user", request);
    };
    ManageUsersClientService.prototype.delete = function (request) {
        return this.requestClient.post("user/delete", {}, request);
    };
    ManageUsersClientService.prototype.getUser = function (userId) {
        return this.requestClient.get("user/" + userId, {});
    };
    ManageUsersClientService.prototype.save = function (request) {
        return this.requestClient.post("user/save", {}, request);
    };
    ManageUsersClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient])
    ], ManageUsersClientService);
    return ManageUsersClientService;
}());
export { ManageUsersClientService };
